<template>
    <div class="shop_area">
        
        <div class="full_content_area shop_content_area" v-if="shopList.length == 0">

            <div class="shop_display_area">
                <div class="shop_back_area display_responsive">
                    <div class="shop_back_btn" @click="$router.replace('/');"></div>
                </div>

                <div class="shop_not_found_div">
                    {{label["shop_list_shop_not_found"]}}
                </div>
            </div>
        </div>

        <div class="full_content_area shop_content_area" v-if="shopList.length > 0">

            <div class="shop_back_area display_responsive">
                <div class="shop_back_btn" @click="$router.replace('/');"></div>
            </div>

            <div class="shop_display_area">

                <div class="title_area">{{label['pickupShop_header_text']}}</div>
                <div class="shop_list_area">

                    <div class="shop_list_div"
                         v-for="(s,index) in shopList"
                         :key="index"
                         :class="{ shop_like: false }">

                        <div class="shop_message_div" v-if="s['shop_list_message'+ getItemSubfix()] != ''">{{s['shop_list_message'+ getItemSubfix()]}}</div>
                        <div class="shop_image_outer_div" @click="selectPickupShop(s)">
                            <div class="shop_image_inner_div">
                                <img :src="getShopImage(s)" loading="lazy" :onerror="'this.onerror=null;this.src=\'/files/images/shop_image/default_shop.png\';'" align="absmiddle" />
                            </div>
                        </div>
                        <div class="shop_name_area">
                            <div class="shop_name_div" @click="selectPickupShop(s)">
                                {{ s["name" + getItemSubfix()] }}
                            </div>
                            <div class="shop_like_div noicon">
                            </div>
                        </div>
                        <div class="shop_address_area">
                            <div class="shop_address_div" @click="selectPickupShop(s)">
                                {{ s["address" + getItemSubfix()] }}
                            </div>
                        </div>

                    </div>

                </div>
                <!-- shop_list_area end -->

            </div>
            <!-- shop_display_area end -->


        </div>
    </div>
</template>
 
<script>
    import MiddlePageTopMenuBar from "../components/MiddlePageTopMenuBar.vue";

    export default {
        data() {
            return {
                shopList: [],
                showShopStatus: true,
                showShopDistance: true,
                currentLocation: undefined,
                currentShop: undefined,
                quoteTimeList: [],

                pickupTime: "",
                timer: -1,
            };
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            }
        },
        components: { MiddlePageTopMenuBar },
        created() {
            // prevent cannot scroll when loading the page
            this.$root.setBodyOverflow(false);
            this.info.itemMenuDetailsOpen = false;

            // check have brand or not
            this.$root.initSelectBrand();
            this.$root.unloadBrandBanner();

            this.$root.setGoBackAction(this.goBack);

            this.$root.getCurrentPathName();

            var app = this;
            app.info.loading = true;
            app.getInitData();

        },
        destroyed() {
            this.$root.setGoBackAction();
            //this.$root.setShowTopBrandDesc(false);
        },
        methods: {
            getShopImage(shop) {
                return this.$root.getShopImage(shop);
                //return "/files/images/shop_image/default_shop.png";
            },
            getInitData() {
                var app = this;
                var continueShopLoading = false;

                // add !CheckOrderModeIsShopping on 20260715 for moving the select to confirmation page 
                if (!app.$root.CheckOrderModeIsShopping) {
                    if (app.$root.info.order_temp_info.order_type == 'pickupShop') {
                        if (app.cart.shopDistrict != "" || (app.$root.info.order_setting.pickupShopAreaFilter && app.cart.shopArea != "")) {
                            continueShopLoading = true;

                            var temp_shop = null;
                            if (app.$root.info.order_setting.pickupShopAreaFilter) {
                                temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType != 'shopping' && s2.visible == 'y' && s2.shopCode.includes("_" + app.$root.getCurrentOrderTypeShopFilterSubfix) && (s2.areaCode == app.cart.shopArea || s2.areaCode == "")));
                            }
                            else {
                                temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType != 'shopping' && s2.visible == 'y' && s2.shopCode.includes("_" + app.$root.getCurrentOrderTypeShopFilterSubfix) && (s2.districtCode == app.cart.shopDistrict || s2.districtCode == "")));
                            }
                            //console.log("temp_shop 1", temp_shop);
                            if (temp_shop.length > 0) {
                                app.shopList = temp_shop.slice();
                            }

                            if (app.$root.info.order_setting.test_pickupShop != undefined && app.$root.info.order_setting.test_pickupShop != null && app.$root.info.order_setting.test_pickupShop.length > 0) {
                                $.each(app.$root.info.order_setting.test_pickupShop, (i, s1) => {
                                    temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopCode_global.toLowerCase() == s1.toLowerCase()));
                                    if (temp_shop.length > 0) {
                                        app.shopList.push(temp_shop[0]);
                                    }
                                });
                            }
                        }
                        else {
                            app.$router.replace(`/`);
                        }
                    }
                    else {
                        app.$router.replace(`/`);
                    }

                    if (continueShopLoading) {
                        app.info.loading = false;
                    }
                }
                else {
                    app.skipPickupShop();
                }
                
            },

            goBack() {
                if (this.currentShop == undefined) return false;
                this.currentShop = undefined;
                return true;
            },
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },
            getShopIcon(item) {
                return `/files/images/ico_shop_${item.code}.png`;
            },
            
            selectPickupShop(shop, isReplace) {                
                if (isReplace == null) isReplace = false;

                var app = this;
                app.info.loading = true;
                this.currentShop = shop;
                //console.log("selectShop", this.currentShop);
                if (this.currentShop == undefined) return;

                //console.log("this.cart", this.cart);
                if (this.cart.token != "" && this.cart.member != null) {

                    if (this.info.order_temp_info.order_address_type == "search") {
                        this.$root.FillMemberInfoToOrderContactInfo();
                        this.$root.setOrderTempInfoData();
                    }
                    //this.$root.createGuestLogin(this.cart.member.name, this.cart.member.phone);       
                }
                else {
                    // get new token before select shop
                    if (this.cart.token == "") {
                        this.$root.createGuestLogin("GUEST", "99999999");
                    }
                }

                // set home select value and update cart value for safe
                if (app.currentShop.districtCode != "") {
                    app.$root.homeSelectShop.homeSelectShopArea = app.currentShop.areaCode;
                    app.$root.homeSelectShop.homeSelectShopDistrict = app.currentShop.districtCode;
                    app.cart.shopArea = app.currentShop.areaCode;
                    app.cart.shopDistrict = app.currentShop.districtCode;
                }
                else {
                    app.cart.shopArea = app.$root.homeSelectShop.homeSelectShopArea;
                    app.cart.shopDistrict = app.$root.homeSelectShop.homeSelectShopDistrict;
                }

                app.cart.pickupShopCode = shop.shopCode_global;
                app.cart.pickupShop = shop;

                app.$root.setOrderTempInfoData();
                app.cart.updateCartOrderInfo(app.info.order_temp_info, app.info.lang);
                app.cart.saveCart();

                app.$root.updateCurrentLLShopList(function () {
                    if (isReplace) {
                        app.$router.replace("shop");
                    }
                    else {
                        app.$router.push("shop");
                    }   
                });                             
            },

            skipPickupShop() {                
                var app = this;
                app.info.loading = true;
                
                //console.log("this.cart", this.cart);
                if (this.cart.token != "" && this.cart.member != null) {

                    if (this.info.order_temp_info.order_address_type == "search") {
                        this.$root.FillMemberInfoToOrderContactInfo();
                        this.$root.setOrderTempInfoData();
                    }
                    //this.$root.createGuestLogin(this.cart.member.name, this.cart.member.phone);       
                }
                else {
                    // get new token before select shop
                    if (this.cart.token == "") {
                        this.$root.createGuestLogin("GUEST", "99999999");
                    }
                }

                // set pickupShopCode if member_prefer_shop_list > 0
                if (app.cart.pickupShopCode == null || app.cart.pickupShopCode == "tempPickupShop") {
                    if (app.$root.member_prefer_shop_list.length > 0) {
                        var temp_shop = [];
                        $.each(app.$root.member_prefer_shop_list, (i, s) => {
                            $.each(app.$root.LLShopList.filter(s1 => s1.shopCode == s), (i, s1) => {
                                temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType != 'shopping' && s2.visible == 'y' && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode)));
                                if (temp_shop.length > 0) {
                                    app.cart.pickupShopCode = temp_shop[0].shopCode_global;
                                    app.cart.pickupShop = temp_shop[0];
                                    return false;
                                }                                
                            });

                            if (app.cart.pickupShopCode != null) return false;
                        });
                    }
                    else {
                        app.cart.pickupShopCode = "tempPickupShop";
                        app.cart.pickupShop = null;
                    }
                }

                // check pickupShopCode again
                if (app.cart.pickupShopCode == null) {
                    app.cart.pickupShopCode = "tempPickupShop";
                    app.cart.pickupShop = null;
                }

                app.cart.saveCart();

                app.$root.updateCurrentLLShopList(function () {
                    app.$router.push("shop");
                });                             
            },

        }
    };
</script>

